import React, { useState } from "react";

const useSnackBar = () => {
    const [ showSnackbar, setShowSnackbar ] = useState(false);
    const [ snackbarContent, setSnackbarContent ] = useState<string | React.ReactNode | undefined>();

    function triggerSnackbar(content: string | React.ReactNode | undefined, autoHideDurationParam: number = 1000) {
        if (!showSnackbar) {
            setSnackbarContent(content);
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
                setSnackbarContent(undefined);
            }, autoHideDurationParam);
        }
    }

    return {
        showSnackbar,
        snackbarContent,
        triggerSnackbar
  };
};

export default useSnackBar;
